namespace GeniuzPOS.InitialData {
    export enum PsPosStationEumConnect2ndDispFg {
        Connect2ndDispFgNo = 0,
        Connect2ndDispFgYes = 1
    }
    Serenity.Decorators.registerEnumType(PsPosStationEumConnect2ndDispFg, 'GeniuzPOS.InitialData.PsPosStationEumConnect2ndDispFg');
}
